import i from "react";
import { createPortal as c } from "react-dom";
import { Link as u } from "../Link/Link.js";
import { VisuallyHidden as p } from "../VisuallyHidden/VisuallyHidden.js";
import { X as d } from "@olxbr/ds-icons";
import { Container as h } from "../Container/Container.js";
import { cls as _ } from "../../helpers/cls.js";
import { Text as f } from "../Text/Text.js";
var g = Object.defineProperty,
  b = (n, e, t) => e in n ? g(n, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : n[e] = t,
  a = (n, e, t) => (b(n, typeof e != "symbol" ? e + "" : e, t), t);
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const r = 5 * 1e3;
class l extends i.Component {
  constructor(e) {
    super(e), a(this, "timeout", 0), a(this, "getActionByProps", (t, o) => !t && o ? "mounting" : t && !o ? "unmounting" : null), a(this, "closeToast", () => {
      clearTimeout(this.timeout), this.props.onClose();
    }), a(this, "initTimer", () => {
      const {
        duration: t = r
      } = this.props;
      t !== "infinite" && t > 0 && (clearTimeout(this.timeout), this.timeout = setTimeout(this.closeToast, t));
    }), a(this, "renderRightContent", () => {
      var t;
      const {
        action: o,
        closable: s
      } = this.props;
      return o != null && o.href && o.text ? i.createElement(u, {
        marginLeft: "--spacing-1",
        href: o.href,
        onClick: (t = o.onClick) != null ? t : void 0,
        size: "caption",
        variant: "inverted"
      }, o.text) : s ? i.createElement("button", {
        className: "olx-toast__close-button",
        onClick: this.closeToast,
        "data-ds-component": "DS-Toast-Button"
      }, i.createElement(d, {
        className: "olx-toast__close-icon",
        "data-testid": "ds-icon-system-x",
        size: 24
      }), i.createElement(p, null, "Fechar")) : null;
    }), this.state = {
      isClient: !1,
      unmount: !e.visible
    };
  }
  static getDerivedStateFromProps(e, t) {
    return e.visible && t.unmount ? {
      unmount: !1
    } : null;
  }
  componentDidMount() {
    this.setState({
      isClient: !0
    }), this.props.visible && this.initTimer();
  }
  componentDidUpdate(e) {
    const {
        visible: t
      } = e,
      {
        visible: o
      } = this.props,
      s = this.getActionByProps(t, o);
    s === "mounting" && this.initTimer(), s === "unmounting" && setTimeout(() => this.setState({
      unmount: !0
    }), 1e3);
  }
  componentWillUnmount() {
    clearTimeout(this.timeout);
  }
  render() {
    const {
        isClient: e,
        unmount: t
      } = this.state,
      {
        icon: o,
        visible: s,
        text: m
      } = this.props;
    return !e || t ? null : c(i.createElement("div", {
      className: "olx-toast__toast-wrapper",
      role: "alert",
      "data-ds-component": "DS-Toast"
    }, i.createElement(h, {
      className: _("olx-toast__body", s && "olx-toast__body--visible"),
      type: "elevated",
      paddingTop: "--spacing-2",
      paddingRight: "--spacing-3",
      paddingBottom: "--spacing-2",
      paddingLeft: "--spacing-3"
    }, o && i.createElement("span", {
      className: "olx-toast__icon-wrapper"
    }, o), i.createElement(f.BodyMedium, {
      className: "olx-toast__text"
    }, m), this.renderRightContent())), document.body);
  }
}
a(l, "defaultProps", {
  visible: !1,
  duration: r
});
export { l as Toast };